import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, initialize, destroy } from 'redux-form'
import FieldLabel from 'components/forms/FieldLabel'
import { CountrySelector } from 'components/forms'
import { Button, Loader } from 'components/util'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import styles from './_country.css'
import * as consentActions from 'services/consents/actions'
import {
  selectConsentMatrixLoading,
  selectConsentRegion,
} from 'services/consents/selectors'
import { changeBulk } from 'shared/actions'

export const FORM_NAME = 'consentCountry'

const validate = (values) => {
  const errors = {}
  if (!values.country) {
    errors.country = 'required'
  }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  matrixLoading: selectConsentMatrixLoading(state),
  consentRegion: selectConsentRegion(state),
})

const mapDispatchToActions = {
  ...consentActions,
  initialize,
  destroy,
  changeBulk,
}

const messages = defineMessages({
  countrySelector: {
    id: 'privacy_center.consents.country.selector',
    defaultMessage: 'Country',
  },
})

export class CountrySelectorForm extends Component {

  static propTypes = {
    intl: PropTypes.object,
    handleSubmit: PropTypes.func,
    fetchConsentMatrix: PropTypes.func,
    matrixLoading: PropTypes.bool,
    consentRegion: PropTypes.string,
    changeBulk: PropTypes.func,
  }

  componentWillMount () {
    const { consentRegion } = this.props
    this.handleCountryChange(undefined, consentRegion)
    setTimeout(() => {
      this.props.changeBulk(FORM_NAME, { country: consentRegion })
    }, 50)
  }

  handleCountryChange = (event, country) => {
    this.props.fetchConsentMatrix(country)
  }

  render () {
    const { handleSubmit, intl, matrixLoading } = this.props
    return (
      <form className={styles.consentCountryForm} method='post' onSubmit={handleSubmit}>
        <FieldLabel
          required
          bold
          labelComponent={(
            <FormattedMessage
              id='privacy_center.consents.country.label'
              defaultMessage='Confirm the country / region where you live.'
            />
          )}
        />
        <CountrySelector
          slim
          name='country'
          placeholder={intl.formatMessage(messages.countrySelector)}
          required={true}
          labelComponent={null}
          onChange={this.handleCountryChange}
          errorComponent={(
            <FormattedMessage
              id='privacy_center.consents.country.required'
              defaultMessage='Country is required'
            />
          )}
        />
        { matrixLoading ? <Loader /> :
          <Button
            el='button'
            type='mmr'
            size='xlarge'
            className={styles.consentNextButton}>
            <FormattedMessage
              id='privacy_center.consents.country.next'
              defaultMessage='Next'
            />
          </Button>
        }
      </form>
    )
  }
}

export const Form = reduxForm(formOptions)(CountrySelectorForm)
export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)
